export default __webpack_public_path__ + "static/media/b.fefe7b79.mp3";